import styled from "styled-components";


export const HeaderContainer = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
color:${(props) => props.theme.textColorPrimary};


`
export const Logo = styled.h2`
font-family:'Poppins',sans-serif;
`
